import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureModulePermission as SharedFeatureModulePermission } from '@nimbus-library/features/feature-permission/feature-permission.module';
import { GraphPermissionResolver } from '@nimbus-library/features/graph/resolver/graph-permission-resolver';
import { FeaturePermissionProviderService } from './services/feature-permission-provider.service';
import { LicenseProviderService } from './services/license-provider.service';
import { AcsDriverApiService } from './services/acs-driver-api.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedFeatureModulePermission.forRoot(FeaturePermissionProviderService, LicenseProviderService, AcsDriverApiService),
  ],
  providers: [GraphPermissionResolver],
  exports: [SharedFeatureModulePermission],
})
export class FeaturePermissionModule {}
